import {
  RESET_VERIFY_EMAIL_STATE,
  VERIFY_EMAIL_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
} from '../types/AuthTypes';

const initialState = {
  loading: false,
  success: null,
  error: null,
};

const verifyEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EMAIL_REQUEST:
      return { ...state, loading: true, success: null, error: null };
    case VERIFY_EMAIL_SUCCESS:
      console.log('reducersdafasdf', action.payload);
      return { ...state, loading: false, success: action.payload, error: null };
    case VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        success: null,
        error: action.payload,
      };
    case RESET_VERIFY_EMAIL_STATE:
      return { ...state, loading: false, success: null, error: null };
    default:
      return state;
  }
};

export default verifyEmailReducer;
